































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import "../BudgetView.scss";
import { Ax } from "@/utils";
import JournalTable from "@/modules/budget/components/Journal.vue";
import store from "@/services/store";

@Component({
    components: { JournalTable }
})
export default class PdfLoader420 extends Vue {
    @Prop({ type: Object, required: true }) propData!: null;
    @Prop({ type: [], required: true })  fileBody!: null;
    @Prop({ type: String })  fileName!: string;
    @Prop({ type: File })  file!: File;

    light: string = "light";
    fields = [
        {
            key: "func",
            label: "Код бюджетной классификации",
            sortable: false,
        },
        {
            key: "espk_code",
            label: "Специфика",
            sortable: false,
        },
        {
            key: "plg",
            label: "План финансирования по обязательствам и платежам на год",
            sortable: false,
        },
        {
            key: "obaz",
            label: "План финансирования с начала года по обязательствам",
            sortable: false,
        },
        {
            key: "plat",
            label: "План финансирования с начала года по платежам",
            sortable: false,
        },
        {
            key: "registrob",
            label: "Сумма принятых обязательств с начала года",
            sortable: false,
        },
        {
            key: "noteexec",
            label: "Невыплаченные обязательства",
            sortable: false,
        },
        {
            key: "sumrg",
            label: "Оплаченные обязательства с начала года",
            sortable: false,
        },
        {
            key: "curr_sumrg",
            label: "Оплаченные обязательства на текущий месяц",
            sortable: false,
        },
    ];

    get userLogin(): string {
        return this.$store.state.user.login;
    }

    async CheckHash(): Promise<void> {
        console.debug(this.file, this.fileName);
        if (!this.file || !this.fileName) return;

        const formData = new FormData();
        formData.append("file", this.file, this.fileName);

        try {
            const response = await fetch("/api-py/check-hash", {
                method: "POST",
                body: formData
            });

            const result = await response.json();
            console.log(result);

            if (result === true) {
                this.handleOk();
            } else {
                this.on420Load(formData);
            }
        } catch (error) {
            console.error("Error checking hash:", error);
        }
    }

    handleOk(): void {
        if (!this.file || !this.file.name) return;

        const formData = new FormData();
        formData.append("file", this.file, this.fileName);

        this.$bvModal
            .msgBoxConfirm("Сохранение приведет к изменению ранее принятых данных", {
                title: "Подтвердите",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "Сохранить",
                cancelTitle: "Отменить",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true
            })
            .then((value: boolean) => {
                console.log("Save", value);
                if (value) {
                    this.on420Load(formData);
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    on420Load(formData: FormData): void {
        const user = this.userLogin;
        this.$emit("save-load420", true);

        Ax({
            url: `/api-py/save-b420/${user}`,
            method: "POST",
            data: formData
        }, data => {
            console.debug("Data", data)
        });

        this.makeToast("success", "Загрузка файла начата! Результат в журнале Загрузки", "Результат");
        this.$emit("save-load420", false);
    }

    onClear(): void {
        this.$emit("form-clear420", {});
    }

    makeToast(variant: string, tostbody: string, title: string): void {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            autoHideDelay: 2000,
            solid: true
        });
    }

    keyEvent(event: KeyboardEvent): void {
        // Обработчик событий клавиатуры (пока пуст)
    }
}

